<header id="page-topbar" data-scroll-header (window:scroll)="windowScroll()">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box horizontal-logo">
          <a routerLink="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="assets/images/logo-icon.png" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/images/logo-light.png" alt="" height="50">
            </span>
          </a>

          <a routerLink="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="assets/images/logo-icon.png" alt="" height="22">
            </span>
            <span class="logo-lg">
              <img src="assets/images/logo-dark.png" alt="" height="70">
            </span>
          </a>
        </div>
        <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
          id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <div class="d-flex align-items-center">
          <button class="btn btn-sm btn-icon btn-topbar btn-ghost-secondary rounded-circle" (click)="goBack()">
            <i class="mdi mdi-keyboard-backspace"></i>
          </button>
          <h4 class="header-item mb-0 fs-5">{{ title }}</h4>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
          <button type="button" class="btn btn-sm btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            ngbDropdownToggle>
            <i class="bx bx-search fs-22"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
            aria-labelledby="page-header-search-dropdown" ngbDropdownMenu>
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                  <button class="btn btn-sm btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="ms-1 header-item d-none d-sm-flex" *ngIf="isMSALLoggedIn">
          <svg class="msal-icon" aria-hidden="true" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"
            itemprop="logo" itemscope="itemscope">
            <path d="M11.5216 0.5H0V11.9067H11.5216V0.5Z" fill="#f25022"></path>
            <path d="M24.2418 0.5H12.7202V11.9067H24.2418V0.5Z" fill="#7fba00"></path>
            <path d="M11.5216 13.0933H0V24.5H11.5216V13.0933Z" fill="#00a4ef"></path>
            <path d="M24.2418 13.0933H12.7202V24.5H24.2418V13.0933Z" fill="#ffb900">
            </path>
          </svg>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-sm btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            data-toggle="fullscreen" (click)="fullscreen()">
            <i class="bx bx-fullscreen fs-22"></i>
          </button>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button"
            class="btn btn-sm btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">
            <i class="bx bx-moon fs-22" (click)="changeMode(modeKey.dark)"></i>
            <i class="bx bx-sun fs-22" (click)="changeMode(modeKey.light)"></i>
          </button>
        </div>

        <!-- <app-notifications></app-notifications> -->
        <a type="button" [routerLink]="'/' + routes.notification"
          class="btn btn-sm btn-icon btn-topbar btn-ghost-secondary rounded-circle">
          <i class='ri-notification-4-fill fs-22 text-primary'></i></a>

        <div class="ms-1 header-item d-none d-sm-flex">
          <span class="badge bg-success">{{userData.DbConnection}}</span>
        </div>

        <div class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>
          <button type="button" class="btn btn-sm" id="page-header-user-dropdown" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <span class="d-flex align-items-center">
              <img class="rounded-circle header-profile-user" src="assets/images/users/avatar.jpg" alt="Header Avatar">
              <span class="text-start ms-xl-2">
                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{userData.name}}</span>
                <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                  {{userData.Branch}}
                </span>
              </span>
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <!-- item-->
            <h6 class="dropdown-header">Welcome {{userData.name}} !</h6>
            <a class="dropdown-item" routerLink="/coming-soon"><i
                class="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Messages</span></a>
            <a class="dropdown-item" [routerLink]="'/' + routes.taskboard"><i
                class="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Taskboard</span></a>
            <!-- <a class="dropdown-item" routerLink="/pages/faqs"><i
                class="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Help</span></a> -->
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" type="button" (click)="changePassword()"><i
                class="mdi mdi-form-textbox-password text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Change Password</span></button>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i
                class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle" data-key="t-logout">Logout</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>